import TweenMax from 'gsap/TweenMax';


const initialState = {
  counter: 0,
  grow: '1em',
  panelContent: ''
}

const reducer = (state = initialState, action) => {
  if(action.type === "INCREMENT"){
    return {
      ...state,
      counter: state.counter + 1
    }
  }
  if(action.type === 'COUNTER_SIZE') {
    let t = 2
    return {
      ...state,
      grow: setInterval(() => {
        t = t + 1
        return t + 'em'
      }, 30)
    }
  }
  if(action.type === "TO_ENTER") {
    return {
      ...state,
      counter: 'Enter'
    }
  }
  if(action.type === "CHANGE_PANEL") {
    const panelContent = action.payload;
    return {
      ...state,
    panelContent
    }
  }

  return state;
}





const test = {
    grow: '1em'
  }
const myFunc = () => {
  let mmm;
  TweenMax.to(test, 2, {grow: '10em', onUpdate: () =>{
    console.log(test.grow)
    mmm = test.grow
  }})
  return mmm
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducer.js